export default function Wrap({children}) {
  return <div className="wrap">{children}</div>
}
